import { render, staticRenderFns } from "./PayModel.vue?vue&type=template&id=3bec51a8&scoped=true"
import script from "./PayModel.vue?vue&type=script&lang=js"
export * from "./PayModel.vue?vue&type=script&lang=js"
import style0 from "./PayModel.vue?vue&type=style&index=0&id=3bec51a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bec51a8",
  null
  
)

export default component.exports